import React, { Fragment, useEffect, useState } from 'react'

// necessary set
import { observer } from 'mobx-react'

// need content
// Props type
import { IPageProps } from '@common/PropsType'

import { PopupData } from './Popup.type'

// need style
import '@pages/popup/popup.scss'

interface Props extends IPageProps {}

/**
 * @author cardo
 * @description
 * sto-user-front: footer
 * 기본 footer
 */
const ONE_DAY = 24 * 60 * 60 * 1000
const filterExpiryDate = (popupData: PopupData) => {
  // return true
  if (popupData.expiry == null || isNaN(popupData.expiry) || popupData.expiry === 0) {
    return true
  }
  const createdDate = new Date(popupData.createdDate)
  const expiryDate = new Date(createdDate.getTime() + popupData.expiry * ONE_DAY)
  const now = new Date()

  return now.getTime() <= expiryDate.getTime()
}
const PopupContainer: React.FC<Props> = observer(() => {
  const [popups, setPopups] = useState([] as PopupData[])
  const loadPopupData = async () => {
    let data = []
    try {
      data = await fetch('https://static.kdac.io/popup/popup.json').then((r) => r.json())
    } catch (e) {
      // do nothing
    }
    const popupList = data as PopupData[]
    const sortedPopups: PopupData[] = popupList
      .filter(filterExpiryDate)
      .sort((a, b) => a.order - b.order) as PopupData[]
    setPopups(sortedPopups)
  }
  useEffect(() => {
    loadPopupData()
  }, [])
  const close = (index: number, popupData: PopupData, neverOpen?: number) => {
    setPopups([...popups.slice(0, index), ...popups.slice(index + 1)])
  }
  if (popups == null || popups.length < 1) {
    return <></>
  }
  return (
    <Fragment>
      <div className="popup-bg">
        <div className="popup-container">
          <div className="popup-area">
            {popups.map((popupData, index) => (
              <div className="popup">
                <div className="tit">{popupData.title}</div>
                <div className="popup-content">
                  <div
                    className={popupData.contentClass ?? 'txt'}
                    dangerouslySetInnerHTML={{ __html: popupData.content }}
                  ></div>
                  {popupData.footer != null && popupData.footer.length > 0 ? (
                    <div className="footer">
                      <div dangerouslySetInnerHTML={{ __html: popupData.footer }}></div>
                    </div>
                  ) : undefined}
                </div>
                <p className="close" onClick={() => close(index, popupData)}>
                  x
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  )
})

export default PopupContainer
